export default __webpack_public_path__ + "static/media/budget.1d265646.svg";